import { render, staticRenderFns } from "./ProcessInfoTab.vue?vue&type=template&id=245789f5"
import script from "./ProcessInfoTab.vue?vue&type=script&lang=js"
export * from "./ProcessInfoTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports